import { Component, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { i } from 'mathjs';
import { Subscription } from 'rxjs';
import { debounce, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PaginationPage } from 'src/app/classes';
import { MailService } from '../../../services/mail.service';

@Component({
  selector: 'app-select-e-mail-address',
  templateUrl: './select-e-mail-address.component.html',
  styleUrls: ['./select-e-mail-address.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectEMailAddressComponent),
      multi: true
    }
  ]
})
export class SelectEMailAddressComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() multiple: boolean = false;
  @Input() label: string = 'E-Mail-Adresse wählen';
  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';

  @ViewChild('trigger') trigger: MatAutocompleteTrigger;

  eMailAddresses: string[] = [];

  formGroup: FormGroup;

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 10 };
  totalItems: number = 0;

  _openPanelAfterLoading: boolean = false;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _mailService: MailService,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      'value': this._formBuilder.control([]),
      'filter': this._formBuilder.control(null, Validators.compose([Validators.required, Validators.email]))
    });
  }

  addAddress(address: string) {
    var value = this.formGroup.controls['value'].value as string[];
    if (!Array.isArray(value)) value = [];
    this.formGroup.controls['value'].patchValue([...value, address]);
    this.formGroup.controls['filter'].reset();
  }

  filterFocusout(){

  }

  loadEMailAddresses() {
    this._mailService.loadMailAddress(this.formGroup.controls['filter'].value, this.page).subscribe((result) => {
      if (result.page.pageNumber === 1) this.eMailAddresses = [];
      this.totalItems = result.totalItems;
      this.eMailAddresses = [...this.eMailAddresses, ...result.content.map(x => x.address)];
      this.page = result.page;
      if (this._openPanelAfterLoading) {
        this.trigger.openPanel();
        this._openPanelAfterLoading = false;
      }
    });
  }

  loadMore(event: MouseEvent = null) {
    this._openPanelAfterLoading = true;
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.page.pageNumber++;
    this.loadEMailAddresses();
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.loadEMailAddresses();
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.formGroup.controls['value'].valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formGroup.disable() : this.formGroup.enable();
  }

  takeFilterValue() {
    if (!this.filterControl.errors) this.addAddress(this.filterControl.value);
  }

  writeValue(val: any): void {
    if (val) this.formGroup.controls['value'].setValue(val);
  }

  get filterControl(): AbstractControl {
    return this.formGroup.controls['filter'];
  }

}
